"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CachedGetter = void 0;
const createCacheKey_1 = require("../utils/createCacheKey");
function CachedGetter(timeInSeconds = Infinity) {
    return function (target, propName, descriptor) {
        if (descriptor.get) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const origFn = descriptor.get;
            descriptor.get = function () {
                const cacheKey = createCacheKey_1.createCacheKey(propName, []);
                const cachedValue = this.getFromCache(cacheKey);
                if (cachedValue) {
                    return cachedValue;
                }
                const result = origFn.call(this);
                this.setCache(cacheKey, result, timeInSeconds);
                return result;
            };
        }
        return descriptor;
    };
}
exports.CachedGetter = CachedGetter;
//# sourceMappingURL=CachedGetter.js.map